import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy, withArtifex } from "core";
import ClientHelper from "core/ClientHelper";
import DateHelper from "core/DateHelper";
import Formatter from "core/Formatter";
import PropTypes from "prop-types";
import React, { Component } from "react";
import ButtonToolbar from "views/Components/ButtonToolbar.jsx";
import { GenericAlert, GenericDateInput, GenericExpansionPanel, GenericGrid, GenericNumberInput, GenericSelectInput } from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";
import { GridColumnType } from "views/Constants/Constant";

class CustomerIdExpireDateList extends Component {
	constructor(props) {
		super(props);

		this.isClient = ClientHelper.IsClient();

		this.initialModel = {
			Id: 0,
			UniqueClientId: this.isClient ? ClientHelper.GetClientRowId() : undefined,
		};

		this.state = {
			alert: null,
			model: { ...this.initialModel },
			list: [],
			isLoading: false
		};

		this.parameterClientType = {
			ParameterCode: "ClientType",
			ParameterValue3: "D"
		};

		this.parameterUniqueClientId = {
			UniqueClientId: this.isClient ? ClientHelper.GetClientId() : undefined
		};

		this.parameterCustomerName = {};

		this.renderItemUniqueClient = {};
		this.renderItemClientCustomer = {};

		this.ColumnsData = [
			{
				Header: "Client Name",
				accessor: "ClientName",
				show: !this.isClient
			},
			{
				Header: "Unique Client Id",
				accessor: "UniqueClientId",
				show: !this.isClient
			},
			{
				Header: "Customer Name",
				accessor: "CustomerName"
			},
			{
				Header: "Client Customer Number",
				accessor: "ClientCustomerNumber"
			},
			{
				Header: "ID Expire Date",
				accessor: "IdentityExpireDate",
				type: GridColumnType.DateUtc
			},
			{
				Header: "Number of Remaining Days",
				accessor: "NumberOfRemainingDays"
			}
		];

		this.sortName = { Member: "Name" };
	}

	componentDidMount() {
		if (this.props.setAppLeftTitle)
			this.props.setAppLeftTitle("Customer ID Expire Date List");
		if (this.props.setAppCenterTitle)
			this.props.setAppCenterTitle("CLIENT");

		this.GetCustomerNameParameter();
	}

	HandleChange = (name, newValue, data) => {
		const model = { ...this.state.model };
		model[name] = newValue;

		if (name === "UniqueClientId") {
			this.GetCustomerNameParameter(model);
		}

		this.setState({ model });
	}

	HandleSearch = () => {
		this.setState({ alert: null, isLoading: true });
		Proxy.POST("/bankapi/v1.0/ClientCustomer/SearchIdVerificationExpiresSoon",
			this.state.model,
			responseData => {
				if (responseData.Item != null && responseData.Item.length > 0) {
					this.setState({ list: responseData.Item, isLoading: false });
				}
				else {
					this.setState({ list: [], isLoading: false });
				}
			},
			this.ErrorCallback
		);
	}

	HandleClear = () => {
		this.setState({ model: { ...this.initialModel } });
	}

	ErrorCallback = (error) => {
		this.setState({ isLoading: false });
		this.ShowMessage("error", "Error", "An error occurred during the api visit" + error);
	}

	RenderItemUniqueClient = (d) => {
		this.renderItemUniqueClient = `${d.UniqueClientId} - ${d.Name}`;
		return this.renderItemUniqueClient;
	}

	RenderItemClientCustomer = (d) => {
		this.renderItemClientCustomer = `${d.ClientCustomerNumber} - ${d.Name}`;
		return this.renderItemClientCustomer;
	}

	GetCustomerNameParameter = (temp) => {
		if (temp) {
			this.parameterCustomerName.UniqueClientId = temp.UniqueClientId;
		} else {
			this.parameterCustomerName.UniqueClientId = this.state.model.UniqueClientId;
		}
		return this.parameterCustomerName;
	}

	ShowMessage = (type, title, message) => {
		this.setState({
			alert: <GenericAlert Title={title} Message={message} Type={type} OnConfirm={() =>
				this.setState({ alert: null })} />
		});
	}

	ShowConfirmMessage = (type, title, message, onConfirm, showCancel = true) => {
		this.setState({
			alert: <GenericAlert Title={title} Message={message} Type={type} ShowCancel={showCancel} OnCancel={() => this.setState({ alert: null })} OnConfirm={onConfirm} />
		});
	}

	render() {
		const { classes, Disabled } = this.props;
		const { model, alert, isLoading, ReadOnly } = this.state;

		return (
			<div>

				<LoadingComponent Show={isLoading} />

				{alert}
				<ButtonToolbar ButtonList={[
					{ Code: "Search", OnClick: this.HandleSearch, Disabled: ReadOnly || Disabled },
					{ Code: "Clear", OnClick: this.HandleClear, Disabled: Disabled }
				]} menuId={this.props.menuId} ApprovalData={this.props.ApprovalData} After={this.props.After} />
				<GridContainer>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardBody>
								<GenericExpansionPanel Title="Filter Panel">
									<GridContainer>
										{!this.isClient &&
											<GridItem xs={3}>
												<GenericSelectInput
													Name="UniqueClientId"
													LabelText="Client"
													Method="POST"
													Url="/bankapi/v1.0/BankCustomer/Search"
													Parameter={this.parameterUniqueClientId}
													DataRoot="Item"
													KeyValueMember="Id"
													RenderItem={this.RenderItemUniqueClient}
													Value={model.UniqueClientId}
													ValueChanged={this.HandleChange}
													CanClear
													All
													Disabled={this.isClient}
													DefaultIndex={this.isClient ? 0 : -1} />
											</GridItem>}
										<GridItem xs={3}>
											<GenericSelectInput
												Name="ClientCustomerId"
												LabelText="Customer Name"
												Method="POST"
												Url="/bankapi/v1.0/ClientCustomer/SearchNameValue"
												Parameter={this.parameterCustomerName}
												DataRoot="Item"
												KeyValueMember="ClientCustomerId"
												RenderItem={this.RenderItemClientCustomer}
												Value={model.ClientCustomerId}
												ValueChanged={this.HandleChange}
												Sorted={this.sortName} />
										</GridItem>
										<GridItem xs={3}>
											<GenericDateInput
												Name="IdentityExpireDate"
												LabelText="ID Expire Date"
												Value={model.IdentityExpireDate ? DateHelper.ToDateInputValue(model.IdentityExpireDate) : ""}
												ValueChanged={this.HandleChange}
												IncludeTime={false}
												IsFuture={true}
												Utc={true} />
										</GridItem>
										<GridItem xs={3}>
											<GenericNumberInput
												Name="NumberOfRemainingDays"
												LabelMd={5}
												LabelText="Number of Remaining Days"
												Value={model.NumberOfRemainingDays}
												ValueChanged={this.HandleChange}
												MaxLength={3}
												NoFormatting={true} />
										</GridItem>
									</GridContainer>
								</GenericExpansionPanel>
							</CardBody>
						</Card>
						<Card className="no-radius">
							<CardBody>
								<GenericExpansionPanel
									Title="ID Expire Date List">
									<GridContainer>
										<GridItem xs={12}>
											<GenericGrid
												Data={this.state.list}
												Columns={this.ColumnsData}
												SelectedIndex={this.state.rowIndex}
												IsSorted={false} />
										</GridItem>
									</GridContainer>
								</GenericExpansionPanel>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>
			</div >
		);
	}
}

CustomerIdExpireDateList.propTypes = {
	classes: PropTypes.object.isRequired,
	setAppLeftTitle: PropTypes.func,
	setAppCenterTitle: PropTypes.func,
	Disabled: PropTypes.bool
};

export default withArtifex(CustomerIdExpireDateList, {});